import { render, staticRenderFns } from "./ErrorReport.vue?vue&type=template&id=f97498c8&"
import script from "./ErrorReport.vue?vue&type=script&lang=js&"
export * from "./ErrorReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports